<template>
    <div class="application pt30 pl30">
        <a href="javascript:;" class="searchbtn w80 text-center bg-green white f14" @click="upApp = true">上传APP</a>
        <div class="mb15 mt15 mr30">
            <template>
                <el-table :data="tableData" border slot="empty">
                    <el-table-column prop="versioncode" label="版本号">
                    </el-table-column>
                    <el-table-column prop="version" label="版本名称">
                    </el-table-column>
                    <el-table-column prop="dec" label="版本描述">
                    </el-table-column>
                    <el-table-column prop="time" label="上传时间">
                    </el-table-column>
                    <el-table-column label="上线状态">
                        <template slot-scope="scope">
                            <p class="red" v-if="scope.row.status == -1"> 未上线 </p>
                            <p v-if="scope.row.status == 1" class="blue">已上线</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="更新状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status == 1">
                                已更新<span class="green">{{scope.row.propsupdatednum}}</span>台 
                                未更新<span class="green">{{scope.row.propsnotupdatednum}}</span>台
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status == -1" class="green cur-p" @click="showTip(scope.row)">上 线</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div v-if="page.totalcount > 10">
                <template>
                    <div class="block pt20 text-right">
                        <el-pagination @current-change="applist" :current-page="page.pageno" :page-size="page.pagesize" layout="total, prev, pager, next, jumper"
                            :total="page.totalcount">
                        </el-pagination>
                    </div>
                </template>
            </div>
        </div>
        <el-dialog title="上传APP" :visible.sync="upApp" width="400" center :closeOnClickModal="false" @close="clearApp">
			<div>
				<el-form label-width="100px">
					<el-form-item label="上传APP包">
						<el-upload
							class="filebox"
							:action="qiniuUrl"
							:on-success="success"
                            :on-remove="handleRemove"
                            :before-upload ="beforeImg"
                            :data="uploadImg"
                            :file-list="fileList">
                            <a href="javascript:;" class="searchbtns">点击上传</a>
						</el-upload>
                    </el-form-item>
                    <el-form-item label="版本号">
                        <el-input placeholder="版本名称" v-model="versionCode"></el-input>
                    </el-form-item>
                    <el-form-item label="版本名称">
                        <el-input placeholder="版本名称" v-model="versionName"></el-input>
                    </el-form-item>
                    <el-form-item label="版本描述">
                        <el-input type="textarea" placeholder="描述版本更新内容" v-model="versionDec"></el-input>
                    </el-form-item>
                </el-form>
                <div class="text-center">
                    <a href="javascript:;" class="searchbtns" @click="addapp">确定</a>
                </div>
			</div>
        </el-dialog>
        <el-dialog title="温馨提示" :visible.sync="upversion" width="400" center :closeOnClickModal="false">
            <p>确定上线 <span class="red"> {{currentName}}</span> 版本吗？</p>
            <div class="text-center mt20">
                <a href="javascript:;" class="searchbtns" @click="appupdatestatus">确 定</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                tableData:[],
                page:{},
                upApp:false,
                qiniuUrl:'',
				domain: '', //图片外链域名
				uploadImg: {
					token: ''
				},
				fileList: [],
                versionName:'',
                versionDec:'',
                currentId:0,
                currentName:'',
                versionCode:'',
                upversion:false,
            }
        },
        created(){
            var that = this;
            that.qiniuUrl = that.api.qiniuUrl;
            that.uploadImgQiniu();
            that.applist(1)
        },
        methods:{
            showTip(val){
                let that = this;
                that.currentId = val.id;
                that.currentName = val.version;
                that.upversion = true;
            },
            //上传图片
			 uploadImgQiniu() {
				var that = this;
				var uploader;
				var req = {}
				req = JSON.stringify(req);
				$.ajax({
					type: 'post',
					url: that.api.getuptoken,
					data: {
						req: req
					},
					success: function (res) {
						if (res.result.success) {
						that.uploadImg.token = res.token;
						that.domain = res.domain;
						}
					}
                })
			},
			//图片上传限制
			beforeImg(file) {
                var that = this;
				var isLt5M = file.size / 1024 / 1024 < 5;
				var name = file.name;
                var suffix = name.substring((name.lastIndexOf('.')+1),name.length)
				if (file.type != 'application/vnd.android.package-archive') {
					this.$message.error('抱歉！上传文件格式有误，请检查之后再上传！');
					return false;
				}
				// if (!isLt5M) {
				// 	this.$message.error('上传文件大小不能超过 5MB!');
				// 	return false;
				// }
			},
			handleRemove(file, fileList) {
				var that = this;
				that.fileList = [];
                $(".filebox .el-upload--text").show();
			},
			success(file, fileList) {
				var that = this;
				var domain = that.domain; //7牛云外链
				var hash = fileList.response.hash; //7牛云返回的图片路径
				var url = domain + hash; //组合成真正的图片地址
				that.fileList.push({ name:fileList.name,url: url,key:hash });
				$(".filebox .el-upload--text").hide();
            },
            addapp(){
                var that = this;
                if(that.fileList.length == 0){
                    that.$message({
                        message:'请上传APP包！',
                        type: 'warning'
                    })
                    return;
                }
                if(!(/^[0-9]+$/.test(that.versionCode))){
                    that.$message({
                        message:'APP版本必须为数字！',
                        type: 'warning'
                    })
                    return;
                } 
                if(that.versionName == ''){
                    that.$message({
                        message:'APP版本名称必填！',
                        type: 'warning'
                    })
                    return;
                }
                var req = {
                    appversion:{
                        type:1000,
                        versioncode:parseInt(that.versionCode),
                        versionname:that.versionName,
                        remark:that.versionDec,
                        url:that.fileList[0].url
                    }
                };
                that.httputil.post({
					that: that,
					url: that.api.addapp,
					req: req,
					xmsuccess: function (res) {
						that.$message({
							message:'上传成功！',
							type: 'success'
                        })
                        that.upApp = false;
                        that.applist(1);
					},
					xmfail: function (res) {
						that.$message({
							message:res.result.reason,
							type: 'warning'
						})
					} 
				});
            },
            applist(page){
                var that = this;
                var req = {
                    type:1000,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                };
                that.tableData = [];
                that.httputil.post({
					that: that,
					url: that.api.applist,
					req: req,
					xmsuccess: function (res) {
						if(res.appversion){
                            for(var i = 0;i<res.appversion.length;i++){
                                var target = res.appversion[i]
                                var json = {
                                    id:target.id,
                                    versioncode:target.versioncode,
                                    version:target.versionname,
                                    dec:target.remark,
                                    status:target.status,
                                    propsupdatednum:target.propsupdatednum?target.propsupdatednum:0,
                                    propsnotupdatednum:target.propsnotupdatednum?target.propsnotupdatednum:0,
                                    time:new Date(target.createtime *1000).format("yyyy/MM/dd HH:mm:ss")
                                }
                                that.tableData.push(json)
                            }
                        }
                        that.page = res.page || {}
					},
					xmfail: function (res) {
						that.$message({
							message:res.result.reason,
							type: 'warning'
						})
					} 
				});
            },
            appupdatestatus(){
                let that = this;
                let req = {
                    id:that.currentId,
                    status:1
                }
                that.httputil.post({
					that: that,
					url: that.api.appupdatestatus,
					req: req,
					xmsuccess: function (res) {
						that.$message({
							message:'上线成功！',
							type: 'success'
                        })
                        that.upversion = false;
                        that.applist(1)
					},
					xmfail: function (res) {
						that.$message({
							message:res.result.reason,
							type: 'warning'
						})
					} 
				});
            },
            clearApp(){
                let that = this;
                that.fileList = [];
                that.versionName = '';
                that.versionDec = '';
                that.versionCode = '';
                $(".filebox .el-upload--text").show();
            }
        }
    }
</script>

<style scoped>
    .searchbtn{
        border-radius: 10px;
        height: 35px;
        line-height: 35px;
        display: inline-block;
    }
    .searchbtns {
		display: inline-block;
		width: 90px;
		height: 35px;
		text-align: center;
		line-height: 35px;
		color: #fff;
		background: #18C3B1;
		margin-left: 14px;
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/application.vue